import React, {useContext} from 'react';
import {Button, Popconfirm} from "antd";
import {DateTimeToMoment} from "./MomentDateTimeConverter";
import {sideMenuContext} from "../../../router/IndexRouter";
import OnFinishMethod from "./OnFinishMethod";
import {GetApiMethod} from "./ApiMethod";
import {camelObj} from "./ConversionMethod";

const GetIdField = (dataMap) => {
    return Object.keys(dataMap).filter(key => key.toLowerCase().endsWith("id"));
}

const DeleteComponent = ({item, postApi, getApi, disabled=false}) => {
    const {dataSource, setDataSource, setCopyDataSource} = useContext(sideMenuContext);
    const idKeys = GetIdField(item);
    const deleteData = async () => {
        // 首先在前端页面删除该条数据（假删除，刷新就出来）
        // 为什么做这么复杂的判断？因为无法直接判断两个对象是否相同，只能判断里面相同的 key 对应的 value是否相同
        // 这就需要遍历所有以 id/Id 结尾的字段，判断他们的值是否相等，全不相等的留下，因为有些数据对应多个 id 字段，比如 user_info 表
        setDataSource(dataSource.filter(data => {
            let results = [];
            // 这个判断逻辑要注意，判断以 id 结尾的字段，值是否相同，以此找到该条数据
            for (let key of idKeys) {
                results.push(data[key] === item[key]);
            }
            // 如果每一项判断都是 true，返回 true，否则返回 false，最后的逻辑取反表示只要有一项不相同就返回 true
            return !results.every(result => result);
        }))
        // 接下来在数据库中删除该条数据
        const deleteObj = {...camelObj(item), state: -1};
        // 将 deleteObj 中属于 DateTime 类型的元素转成 Moment 类型，然后在 PostAPIMethod 中再转成 Datetime 保存到数据库中
        const postData = Object.keys(deleteObj).length > 0 ? DateTimeToMoment(deleteObj) : {};
        await OnFinishMethod(postData, postApi);
    }
    const deleteMethod = () => {
        // 将数据从页面和数据库中删除后，再重新请求一遍数据库，实现数据更新操作，为了获取最新数据，需要加入延迟请求，且这个延迟可以接受
        deleteData().then(() => {
            setTimeout(() =>
                GetApiMethod({getApi, setDataSource, setCopyDataSource}), 500)
        });
    }

    return (
        <Popconfirm
            placement="topRight"
            title='确定要删除这条记录吗?'
            description=' '
            onConfirm={deleteMethod}
            okText="确定"
            cancelText="取消"
            disabled={disabled}
        >
            <Button type="link" danger disabled={disabled}>删除</Button>
        </Popconfirm>
    );
};

export default DeleteComponent;
